module.exports = __webpack_public_path__ + "img/icon_2_4.1f956d65.png";